import React from "react";
import { Typography, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";

const getSentenceTokens = (sentence) => {
  if (typeof sentence !== "string") {
    return [];
  }

  return sentence
    .trim()
    .split(/\s+/)
    .map((token) => token.trim())
    .filter(Boolean);
};

const normalizeSentenceValue = (sentence) =>
  getSentenceTokens(sentence).join(" ");

const ReArrange = ({ currentActivity, rearrangeSelections }) => {
  const userSentence = normalizeSentenceValue(
    rearrangeSelections?.[currentActivity?.ContentId]
  );

  const correctSentences = Array.isArray(currentActivity?.Options)
    ? currentActivity.Options.map((option) =>
        normalizeSentenceValue(option?.Value)
      ).filter(Boolean)
    : [];

  const isCorrect =
    Boolean(userSentence) &&
    correctSentences.some((sentence) => sentence === userSentence);

  const isRtlDirection =
    typeof currentActivity?.Direction === "string" &&
    currentActivity.Direction.toUpperCase() === "RTL";

  return (
    <>
      {isCorrect ? (
        <>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CheckCircleOutlineIcon sx={{ fontSize: 40, color: "green" }} />
          </Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "green",
              marginTop: 1,
              textAlign: "center",
            }}
          >
            Correct Answer!
          </Typography>
        </>
      ) : (
        <>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CancelIcon sx={{ fontSize: 40, color: "red" }} />
          </Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "red",
              marginTop: 1,
              textAlign: "center",
            }}
          >
            Incorrect Answer!
          </Typography>
        </>
      )}

      {currentActivity.Options?.some((option) => option.Rationale?.Text) ? (
        currentActivity.Options.map((option, index) => {
          const rationaleText = option.Rationale?.Text?.trim();
          const rationaleContentId = option.Rationale?.ContentId?.trim();

          return (
            <Typography
              key={index}
              dir={isRtlDirection ? "rtl" : "ltr"}
              sx={{
                marginTop: 1,
                fontSize: "0.75rem",
                color: "text.secondary",
                padding: "8px",
                margin: "8px 0",
                textAlign: isRtlDirection ? "right" : "left",
                direction: isRtlDirection ? "rtl" : "ltr",
              }}
            >
              {rationaleText
                ? `Rationale: ${rationaleText}`
                : rationaleContentId
                ? `Rationale ID: ${rationaleContentId}`
                : "No rationale available."}
            </Typography>
          );
        })
      ) : (
        <Typography
          dir={isRtlDirection ? "rtl" : "ltr"}
          sx={{
            fontSize: "0.9rem",
            fontStyle: "italic",
            color: "#999",
            marginTop: 1,
            textAlign: isRtlDirection ? "right" : "left",
            direction: isRtlDirection ? "rtl" : "ltr",
          }}
        >
          Rationale: Not available
        </Typography>
      )}
    </>
  );
};

export default ReArrange;
